import { instance } from '../lib/api'

export const FILE_UPLOAD_SUCCESS = 'FILE_UPLOAD_SUCCESS'
export const FILE_UPLOAD_FAIL = 'FILE_UPLOAD_FAIL'
export const FILE_UPLOAD_CHOSEN = 'FILE_UPLOAD_CHOSEN'

export const chooseFile = () => {
  return dispatch => {
    dispatch({
      type: FILE_UPLOAD_CHOSEN
    })
  }
}

export const uploadFile = file => {
  return dispatch => {
    const url = '/mystique/v1/rcm/csv-upload?csvType=RCM_BANK_CSV&debug=true'
    const data = new FormData()
    data.append('file', file)
    const config = {
      headers: {
        'content-type': 'multipart/form-data'
      }
    }

    return instance({
      url,
      method: 'post',
      data,
      config
    })
      .then(response => {
        dispatch({
          type: FILE_UPLOAD_SUCCESS,
          payload: response.data.data
        })
      })
      .catch(err => {
        dispatch({
          type: FILE_UPLOAD_FAIL,
          payload: err
        })
      })
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/uploadcsv.js
 **/